import type { JSX } from 'react';

// Type pour le contenu contextuel
export type ContentValue = string | string[] | JSX.Element | JSX.Element[] | ((data?: Record<string, any>) => JSX.Element);
export type ContentContext = 'site' | 'conseiller' | 'courtier' | 'concessionnaire' | 'conseillermae';

export interface ContentItem {
    site?: ContentValue;
    conseiller?: ContentValue;
    courtier?: ContentValue;
    concessionnaire?: ContentValue;
    conseillermae?: ContentValue;
    fallback?: ContentValue;
}

export type StepContentConfig = Record<string, ContentItem>;

// Type de retour unifié
export type RenderedContent = string | JSX.Element | JSX.Element[];

// Helper pour déterminer le contenu à afficher
export function resolveContent(
    contentItem: ContentItem,
    context: ContentContext = 'site'
): ContentValue {
    // 1. Essayer le contexte demandé
    if (contentItem[context] !== undefined) {
        return contentItem[context]!;
    }

    // 2. Fallbacks intelligents
    const fallbacks: Record<ContentContext, ContentContext[]> = {
        conseiller: ['courtier', 'site'],
        conseillermae: ['conseiller', 'courtier', 'site'],
        concessionnaire: ['site'],
        courtier: ['conseiller', 'site'],
        site: []
    };

    for (const fallback of fallbacks[context]) {
        if (contentItem[fallback] !== undefined) {
            return contentItem[fallback]!;
        }
    }

    // 3. Fallback explicite ou site par défaut
    return contentItem.fallback ?? contentItem.site ?? '';
}
